// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__F7yi5","without_margin":"Loader_without_margin__WdY00","app_loader":"Loader_app_loader__2wrt+"};